import { ITrialCalendarSlot } from "../../../entities/trialLesson";
import { useCalendarSlotSelection } from "../../../shared/lib/hooks/useCalendarSlotSelection";

interface ISelectedTrialPeriod {
    startsAt: Date;
    durationSlots: number;
}

interface IProps {
    slots: Date[];
    calendarSlotsByIndex: Map<number, ITrialCalendarSlot>;
    enabled: boolean;
    requiredDurationSlots?: number;
    onSelectPeriod: (period: ISelectedTrialPeriod) => void;
}

const canCreateTrialInSlot = (slot?: ITrialCalendarSlot): boolean => {
    return slot?.availabilityStatus === 'TRIAL_SLOT_AVAILABILITY_STATUS_AVAILABLE' &&
            Boolean(slot.availableActions.includes('CALENDAR_SLOT_ACTION_CREATE_TRIAL_LESSON'))
}

export const useTrialCalendarDaySelection = ({
    slots, calendarSlotsByIndex, enabled, requiredDurationSlots, onSelectPeriod,
}: IProps) => {
    return useCalendarSlotSelection<ITrialCalendarSlot>({
        slots,
        calendarSlotsByIndex,
        canSelectSlot: slot => enabled && canCreateTrialInSlot(slot),
        fixedDurationSlots: requiredDurationSlots,
        onSelectPeriod,
    })
}
